import axios from "axios";
import React, { useState, useContext, useEffect } from "react";
// import { BASE_URL } from "../constants/api_urls";
import { AuthContext } from "../context/AuthContext";
import { AppStateContext } from "../context/AppContext";
import apiPath from "../constants/apiPath";
const client = axios.create({
  baseURL: apiPath.baseURL,
});

const useRequest = () => {
  const { logout } = useContext(AuthContext);
  const { setLoading } = useContext(AppStateContext);

  const request = async ({
    url,
    method: tmethod,
    data,
    onSuccess,
    onError,
    header,
    onErrorSubmit,
    signal, // optional AbortController signal — lets callers cancel in-flight calls
  }) => {
    const method = tmethod.trim().toUpperCase();
    let token = localStorage.getItem("admin_token")
      ? localStorage.getItem("admin_token")
      : "";

    const headers = {
      ...header,
      Authorization: `Bearer ${token}`,
    };

    setLoading(true);
    try {
      const response = await client({
        url,
        method,
        data,
        headers: { ...headers },
        signal,
      });

      if (onSuccess) {
        // console.log(response.data, "response")
        setLoading(false);
        onSuccess(response.data);
      }
      if (typeof onErrorSubmit === "function") {
        onErrorSubmit(response.data);
      }
      setLoading(false);
      return response.data;
    } catch (err) {
      console.log(err);
      if (err?.response?.status === 401) {
        logout();
      }
      if (err?.response?.data?.message === "jwt expired") {
        logout();
      }
      if (onError) {
        onError(err);
      }
      setLoading(false);
      // throw err;
    } finally {
      setLoading(false);
    }
  };

  return { request };
};

export default useRequest;
